/* eslint-disable no-underscore-dangle */
/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import './css/DestinationSearch.css';
import { connect } from 'react-redux';
// import HttpsAgent from 'https-agent';
import { ReactComponent as CrossIco } from '../../../../images/input-cross.svg';
import {
  changeSearchResult,
  changeSearchInputValue,
  changeDestination,
  changeResortOptions,
  changeSelectedResorts,
} from '../../../../DataStore/actions/searchFormActions';
import { changeHotelsFilter } from '../../../../DataStore/actions/FiltersAction';
import {
  searchCountries,
  searchCities,
  searchHotels,
} from '../../../../Utils/ElasticUtils';
import {
  TOUR_SEARCH_REGIONS_INDEX,
  TOUR_SEARCH_HOTELS_INDEX,
} from '../../../../Utils/Constants/Indexes';

const mapStateToProps = (state) => ({ ...state });

class DestinationSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const {
      destination,
      changeSearchInputValue: changeSearchInputValueFunc,
      hotelsFilter,
    } = this.props;

    let result;
    if (hotelsFilter.length > 0) {
      if (hotelsFilter.length === 1) {
        result = hotelsFilter[0].name;
      } else if (hotelsFilter.length < 5) {
        result = `${hotelsFilter.length} отеля`;
      } else {
        result = `${hotelsFilter.length} отелей`;
      }
    } else {
      result = destination.name;
    }

    changeSearchInputValueFunc(result);
    this.input.focus();
  }

  handleChange = (e) => {
    const {
      changeSearchResult: changeSearchResultAciton,
      changeSearchInputValue: changeSearchInputValueFunc,
    } = this.props;

    let isAllCities = false;
    const { value } = e.target;

    changeSearchInputValueFunc(value);

    if (value.length >= 1) {
      searchCountries(value.trim(), TOUR_SEARCH_REGIONS_INDEX).then(
        (countryRes) => {
          // eslint-disable-next-line no-underscore-dangle
          const countriesResult = countryRes.data.hits.hits.map(
            (h) => h._source,
          );

          countriesResult.sort(this.compareRankFn);

          if (countriesResult.length > 5) {
            changeSearchResultAciton(countriesResult);
            return;
          }

          if (countriesResult.length === 0) {
            isAllCities = true;
          }

          searchCities(
            value.trim(),
            countriesResult,
            isAllCities,
            TOUR_SEARCH_REGIONS_INDEX,
          ).then((cityRes) => {
            // eslint-disable-next-line no-underscore-dangle
            const citiesResult = cityRes.data.hits.hits.map((h) => h._source);
            citiesResult.sort(this.compareName);

            let cities;
            if (isAllCities) {
              cities = citiesResult;
            } else {
              cities = citiesResult.filter(
                (cityItem) => cityItem.popular === true,
              );
            }

            if (cities.length !== 0) {
              changeSearchResultAciton(countriesResult.concat(cities));
            } else if (countriesResult.length !== 0) {
              changeSearchResultAciton(countriesResult);
            } else {
              searchHotels(value.trim(), TOUR_SEARCH_HOTELS_INDEX).then(
                (hotelsResult) => {
                  const hotels = hotelsResult.data.hits.hits.map(
                    (h) => h._source,
                  );

                  changeSearchResultAciton(hotels);
                },
              );
            }
          });
        },
      );
    }
  };

  compareRankFn = (a, b) => {
    if (a.rank > b.rank) {
      return 1;
    }
    if (a.rank < b.rank) {
      return -1;
    }
    return 0;
  };

  compareName = (a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  };

  handleClick = () => {
    const {
      changeSearchInputValue: changeSearchInputValueFunc,
      changeHotelsFilter: changeHotelsFilterAction,
      hotelsFilter,
    } = this.props;

    changeSearchInputValueFunc('');

    if (hotelsFilter.length > 0) {
      changeHotelsFilterAction([]);
    }

    this.input.focus();
  };

  render() {
    const { searchInputValue } = this.props;
    return (
      <div className="sf_dest_search_input_w">
        <input
          value={searchInputValue}
          className="sf_dest_search_input bm_text_18"
          ref={(e) => {
            this.input = e;
          }}
          onChange={this.handleChange}
        />
        <div
          onClick={this.handleClick}
          onKeyDown={() => {}}
          role="button"
          tabIndex={0}
          className="sf_dest_search_cross_w"
        >
          <CrossIco className="sf_dest_search_cross" />
        </div>
      </div>
    );
  }
}

DestinationSearch.propTypes = {
  destination: PropTypes.instanceOf(Object).isRequired,
  changeSearchResult: PropTypes.func.isRequired,
  searchInputValue: PropTypes.string.isRequired,
  changeSearchInputValue: PropTypes.func.isRequired,
  hotelsFilter: PropTypes.instanceOf(Array).isRequired,
  changeHotelsFilter: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {
  changeSearchResult,
  changeSearchInputValue,
  changeDestination,
  changeResortOptions,
  changeSelectedResorts,
  changeHotelsFilter,
})(DestinationSearch);
